import * as React from 'react'

const LightningIcon = (props: { foreground: React.SVGProps<SVGPathElement>['fill'] }) => (
  <div style={{ width: 24, height: 24 }}>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M12.5 14l3.031-11.26c.132-.49-.464-.842-.83-.49L4.287 12.28c-.648.624-.206 1.72.694 1.72h7.52z"
        fill={props.foreground}
      />
      <path
        d="M11.5 10L8.469 21.26c-.132.49.464.841.83.49l10.415-10.03c.648-.624.206-1.72-.694-1.72H11.5z"
        fill={props.foreground}
      />
    </svg>
  </div>
)

export default LightningIcon
